import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule],
})
export class SpinnerComponent {
  @Input() display = false;
  @Input() class!: string;
  @Input() diameter = 100;
  @Input() messageToDisplay = '';
}
